import React from 'react';
// This import gives you the public URL of the SVG file
import maintenanceImageUrl from './MaintenanceIcon.svg';

const styles: { [key: string]: React.CSSProperties } = {
  maintenanceContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100vw',
  },
  maintenanceImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  }
};

const MaintenancePage = () => {
  return (
    <div style={styles.maintenanceContainer}>
      <img 
        src={maintenanceImageUrl} 
        style={styles.maintenanceImage} 
        alt="Site under maintenance" 
      />
    </div>
  );
};

export default MaintenancePage;